import PracticeLesson from './PracticeLesson'

export default PracticeLesson
